import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Stack,
  Box,
  IconButton,
  Chip,
  Button,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

type TemplateType = "Permissions" | "Guardrails";
type ImpactLevel = "Low" | "Moderate" | "High";

interface TemplateRow {
  id: number;
  name: string;
  type: TemplateType;
  impact: ImpactLevel | string;
  lastModified: string;
  visibility: string;
}

const rows: TemplateRow[] = [
  {
    id: 1,
    name: "Basic Vendor Tier Permissions",
    type: "Permissions",
    impact: "Low",
    lastModified: "Feb 18, 2024",
    visibility: "Default",
  },
  {
    id: 2,
    name: "Basic Listing Guardrails",
    type: "Guardrails",
    impact: "Moderate",
    lastModified: "Feb 18, 2024",
    visibility: "Default",
  },
  {
    id: 3,
    name: "Moderate Guardrail Template",
    type: "Guardrails",
    impact: "High",
    lastModified: "Feb 17, 2024",
    visibility: "Default & common",
  },
  {
    id: 4,
    name: "Admins Only Permissions Set",
    type: "Permissions",
    impact: "Modules, Listings, Electronics",
    lastModified: "Feb 17, 2024",
    visibility: "Default",
  },
  {
    id: 5,
    name: "Healthcare Approval Rules",
    type: "Permissions",
    impact: "High",
    lastModified: "Feb 17, 2024",
    visibility: "Custom",
  },
];

const getImpactStyles = (impact: ImpactLevel | string) => {
  if (impact === "Low")
    return { bg: "#f5e6d8", color: "#b45309" };
  if (impact === "Moderate")
    return { bg: "#e6f4ea", color: "#166534" };
  if (impact === "High")
    return { bg: "#fde2e2", color: "#991b1b" };
  return { bg: "#f3f4f6", color: "#374151" };
};

const TemplateTable: React.FC = () => {
  return (
    <div className="lt">
      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow sx={{ background: "#f6f6f8" }}>
              <TableCell>Sr. No.</TableCell>
              <TableCell>
                <Stack direction="row" alignItems="center" spacing={0.5}>
                  Template Name
                 
                </Stack>
              </TableCell>
              <TableCell>
                <Stack direction="row" alignItems="center" spacing={0.5}>
                  Template Type
                 
                </Stack>
              </TableCell>
              <TableCell>
                <Stack direction="row" alignItems="center" spacing={0.5}>
                  Impact Level
                 
                </Stack>
              </TableCell>
              <TableCell>
                <Stack direction="row" alignItems="center" spacing={0.5}>
                  Last Modified
                 
                </Stack>
              </TableCell>
              <TableCell>
                <Stack direction="row" alignItems="center" spacing={0.5}>
                  Visibility
                 
                </Stack>
              </TableCell>
              <TableCell>Actions</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {rows.map((row, index) => {
              const impactStyle = getImpactStyles(row.impact);
              return (
                <TableRow key={row.id} hover>
                  <TableCell>{index + 1}.</TableCell>

                  <TableCell>
                    <Typography fontWeight={500}>
                      {row.name}
                    </Typography>
                  </TableCell>

                  <TableCell>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <Box
                        sx={{
                          width: 10,
                          height: 10,
                          borderRadius: "50%",
                          background:
                            row.type === "Permissions"
                              ? "#8b5cf6"
                              : "#10b981",
                        }}
                      />
                      <Typography>{row.type}</Typography>
                    </Stack>
                  </TableCell>

                  <TableCell>
                    {row.impact === "Low" ||
                    row.impact === "Moderate" ||
                    row.impact === "High" ? (
                      <Chip
                        label={row.impact}
                        size="small"
                        sx={{
                          background: impactStyle.bg,
                          color: impactStyle.color,
                          fontWeight: 500,
                        }}
                      />
                    ) : (
                      <Typography>{row.impact}</Typography>
                    )}
                  </TableCell>

                  <TableCell>{row.lastModified}</TableCell>

                  <TableCell>{row.visibility}</TableCell>

                  <TableCell>
                    <Button
                      size="small"
                      startIcon={<VisibilityOutlinedIcon />}
                      sx={{
                        textTransform: "none",
                        background: "#f3f4f6",
                      }}
                    >
                      Apply
                    </Button>
                  </TableCell>

                  <TableCell>
                    <Stack direction="row" spacing={1}>
                      <IconButton size="small">
                        <EditOutlinedIcon fontSize="small" />
                      </IconButton>
                      <IconButton size="small">
                        <MoreHorizIcon fontSize="small" />
                      </IconButton>
                    </Stack>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>

        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          p={2}
        >
          <Typography variant="body2">
            1 to {rows.length} of {rows.length}
          </Typography>

          <Stack direction="row" spacing={1}>
            <IconButton size="small">{"<"}</IconButton>
            <Chip label="1" size="small" />
            <IconButton size="small">{">"}</IconButton>
          </Stack>
        </Box>
      </TableContainer>
    </div>
  );
};

export default  TemplateTable;
